import { Injectable } from '@angular/core';
import { WebSocketEventRoutingService } from './web-socket-event-routing.service';
import { WSEventType } from '../../../models/WSEventType';
import { Observable, Subject } from 'rxjs/Rx';

@Injectable({
  providedIn: 'root'
})
export class NotificationWebSocketHandlerService {

  private _notificationSubject: Subject<any>;
  private readonly _notificationObservable: Observable<any>;

  constructor(private _webSocketEventRoutingService: WebSocketEventRoutingService) {
    let subject = new Subject<any>();
    subject.asObservable().subscribe(payment => {
      this.processNotification(payment);
    });
    this._webSocketEventRoutingService.subscribe(WSEventType.CHANGE_VIEW, subject);
    this._webSocketEventRoutingService.subscribe(WSEventType.OFFER_MPAY, subject);
    this._notificationSubject = new Subject<any>();
    this._notificationObservable = this._notificationSubject.asObservable();
  }

  get notificationObservable() {
    return this._notificationObservable;
  }

  private processNotification(notification: any) {
    this._notificationSubject.next(notification);
  }
}
